import React from 'react';

const UserContext = React.createContext(undefined!)
const DeckContext = React.createContext(undefined!)
const CardContext = React.createContext(undefined)

export {UserContext, DeckContext, CardContext};
